import type { LinkProps } from "@tanstack/react-router";
import { Activity, Bot, Landmark, PoundSterling, Rocket, ScrollText, Settings, ShieldCheck, Workflow } from "lucide-react";
import type { ReactNode } from "react";

export interface ProjectNavItem {
  key: "canvas" | "deployments" | "logs" | "metrics" | "safety" | "spend" | "agents" | "settings" | "compliance";
  to: LinkProps["to"];
  label: string;
  icon: ReactNode;
  exact?: boolean;
  /** Keyboard shortcut after pressing g (e.g. g then l for Logs). */
  key2: string;
}

/** Project navigation, in the order of docs/12 §3. */
export const projectNav: ProjectNavItem[] = [
  { key: "canvas", to: "/$workspace/$project", label: "Canvas", icon: <Workflow />, exact: true, key2: "c" },
  { key: "deployments", to: "/$workspace/$project/deployments", label: "Deployments", icon: <Rocket />, key2: "d" },
  { key: "logs", to: "/$workspace/$project/logs", label: "Logs", icon: <ScrollText />, key2: "l" },
  { key: "metrics", to: "/$workspace/$project/metrics", label: "Metrics", icon: <Activity />, key2: "m" },
  { key: "safety", to: "/$workspace/$project/safety", label: "Safety Centre", icon: <ShieldCheck />, key2: "s" },
  { key: "spend", to: "/$workspace/$project/spend", label: "Spend", icon: <PoundSterling />, key2: "p" },
  { key: "agents", to: "/$workspace/$project/agents", label: "Agents", icon: <Bot />, key2: "a" },
  { key: "settings", to: "/$workspace/$project/settings", label: "Settings", icon: <Settings />, key2: "," },
  { key: "compliance", to: "/$workspace/$project/compliance", label: "Compliance", icon: <Landmark />, key2: "o" },
];
